import React from 'react';

import {get} from 'react-hook-form';

import {buildFieldName} from './buildFieldName';
import {getFieldRenderer} from './fieldRendererRegistry';

export const renderFormFields = (formPrefixName, fields, control, watchValues) =>
  fields.map(field => {
    // eslint-disable-next-line testing-library/render-result-naming-convention
    const Renderer = getFieldRenderer(field);

    const isDisabled = typeof field.disabled === 'function' ? field.disabled({watchValues}) : false;

    const Wrapper = field.wrapper?.component || React.Fragment;
    const wrapperProps = field.wrapper?.props || {};
    const formErrors = formPrefixName ? get(control._formState.errors, formPrefixName) : control._formState.errors;
    const fieldError = formErrors ? formErrors[field.name] : null;

    return (
      <Wrapper key={field.name} {...wrapperProps}>
        <Renderer error={!!fieldError} helperText="Champ requis" control={control} field={field} prefix={formPrefixName} disabled={isDisabled} watchValues={watchValues} />
      </Wrapper>
    );
  });
